import { useStableRows } from '~/client/src/shared/hooks/useStableRows'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'
import { formatPropertyType } from '~/client/src/shared/utils/propertyTypeUtils'

import { IResourcePropertyRow, ResourceProperty } from './types'

export function useResourcePropertyRows(
  properties: readonly ResourceProperty[],
  projectDateStore?: ProjectDateStore,
): IResourcePropertyRow[] {
  const formatDateTime = (value?: string | null) => {
    if (!value) return ''
    try {
      return projectDateStore?.format(new Date(value)) || String(value)
    } catch {
      return String(value)
    }
  }

  const rows = properties.map(property => ({
    id: property.name,
    label: property.displayName || '',
    name: property.name || '',
    type: formatPropertyType(property.propertyType, property.configuration),
    source: property.createdBy
      ? Localization.translator.custom
      : Localization.translator.default,
    status: property.isArchived
      ? Localization.translator.archived
      : Localization.translator.active,
    createdBy: property.createdBy || null,
    isArchived: property.isArchived ?? false,
    updatedAt: formatDateTime(property.updatedAt as any),
  }))

  return useStableRows(rows)
}
